module.exports = __webpack_public_path__ + "static/media/fa-regular-400.bbd1e7a4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/webfonts/fa-regular-400.ttf
// module id = 739
// module chunks = 0